import Blockly from 'blockly';
import 'blockly/javascript';

Blockly.JSON = new Blockly.Generator('JSON');
Blockly.JSON.PRECEDENCE = 0;
Blockly.JSON.ORDER_ATOMIC = 1;

Blockly.JSON.workspaceToCode = (workspace) => {
    const parent = workspace.getBlocksByType('command_definition')[0];
    return Blockly.JSON.blockToCode(parent);
};

Blockly.JSON.isInitialized = true;

Blockly.JSON.statementToCode = (block, name) => {
    let targetBlock = block.getInputTargetBlock(name);
    let code = [Blockly.JSON.blockToCode(targetBlock)];

    if (targetBlock) {
        let nextBlock = targetBlock.getNextBlock()
        while (nextBlock) {
            code.push(Blockly.JSON.blockToCode(nextBlock));
            nextBlock = nextBlock.getNextBlock()
        }
    }

    return code;
};

Blockly.JSON.valueToCode = (block, name) => {
    let targetBlock = block.getInputTargetBlock(name);

    if (!targetBlock) {
        return null;
    }

    return Blockly.JSON.blockToCode(targetBlock);
};

Blockly.JSON.blockToCode = (block, thisOnly) => {
    if (!block) {
        return null;
    }

    let func = Blockly.JSON[block.type];
    if (typeof func !== 'function') {
        throw Error(`Language "${Blockly.JSON.name_}" does not know how to generate code for block type "${block.type}".`);
    }

    let code = func.call(block, block);
    if (typeof code === 'object' && code !== null) {
        return code;
    } else if (typeof code === 'string') {
        return null;
    } else if (code === null || code === undefined) {
        return null;
    }

    throw SyntaxError(`Invalid code generated: ${code}`)
}
